import { render } from "./SavedStyleSelector.vue?vue&type=template&id=23851650"
import script from "./SavedStyleSelector.vue?vue&type=script&lang=js"
export * from "./SavedStyleSelector.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/OpenMCT/OpenMCT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__